export default {
  name: "EmailDialogDelete",
  data() {
    return {
      dialog: false,
      reject: null,
      message: null,
      outputMsg: "",
      title: null,
      resolve: null,
      hasTextField: false,
      textFieldLabel: "Note",
      isAgree: false,
      isDelete: true,
      options: {
        color: "#3f51b5",
        width: 605,
        zIndex: 200,
        noconfirm: false
      }
    }
  },
  methods: {
    open(title, message, hasTextField, textFieldLabel, options, isDelete) {
      this.dialog = true;
      this.title = title;
      this.hasTextField = hasTextField;
      this.textFieldLabel = textFieldLabel;
      this.message = message;
      this.options = Object.assign(this.options, options);
      this.isDelete = isDelete;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.isAgree = true;
      this.resolve({ agree: true, message: this.outputMsg });
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.isAgree = false;
    },
  }
}